function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint class-methods-use-this: "off" */

import { getOrThrow } from '@deephaven/utils';
import { isEditableGridModel } from "../EditableGridModel.js";
import GridMouseHandler from "../GridMouseHandler.js";
import GridRange from "../GridRange.js";
import GridUtils, { isLinkToken } from "../GridUtils.js";
import { isTokenBoxCellRenderer } from "../TokenBoxCellRenderer.js"; // Handler also helps with other tooltips
class GridTokenMouseHandler extends GridMouseHandler {
  constructor() {
    super(...arguments);
    _defineProperty(this, "timeoutId", void 0);
    _defineProperty(this, "isHold", false);
    _defineProperty(this, "isDown", false);
    // Stores the current hovered token box if it exists with translated coordinates
    _defineProperty(this, "currentLinkBox", void 0);
  }
  isHoveringLink(gridPoint, grid) {
    var column = gridPoint.column,
      row = gridPoint.row,
      x = gridPoint.x,
      y = gridPoint.y;
    var renderer = grid.renderer,
      metrics = grid.metrics,
      props = grid.props;
    var model = props.model;
    if (column == null || row == null || metrics == null) {
      this.currentLinkBox = undefined;
      return false;
    }
    var modelRows = metrics.modelRows,
      modelColumns = metrics.modelColumns;
    var modelRow = getOrThrow(modelRows, row);
    var modelColumn = getOrThrow(modelColumns, column);
    var renderType = model.renderTypeForCell(modelColumn, modelRow);
    var cellRenderer = renderer.getCellRenderer(renderType);
    if (!isTokenBoxCellRenderer(cellRenderer)) {
      return false;
    }
    if (this.currentLinkBox != null) {
      var _this$currentLinkBox = this.currentLinkBox,
        left = _this$currentLinkBox.x1,
        top = _this$currentLinkBox.y1,
        right = _this$currentLinkBox.x2,
        bottom = _this$currentLinkBox.y2;
      if (x >= left && x <= right && y >= top && y <= bottom) {
        return true;
      }
    }
    var renderState = grid.updateRenderState();
    var tokensInCell = cellRenderer.getTokenBoxesForVisibleCell(column, row, renderState);

    // Loop through each link and check if cursor is in bounds
    for (var i = 0; i < tokensInCell.length; i += 1) {
      if (isLinkToken(tokensInCell[i].token)) {
        var translatedTokenBox = GridUtils.translateTokenBox(tokensInCell[i], metrics);
        var _left = translatedTokenBox.x1,
          _right = translatedTokenBox.x2,
          _top = translatedTokenBox.y1,
          _bottom = translatedTokenBox.y2;
        if (x >= _left && x <= _right && y >= _top && y <= _bottom) {
          this.currentLinkBox = translatedTokenBox;
          return true;
        }
      }
    }

    // If this point is reached, that means the cursor was not hovering any of the links or there are no links
    this.currentLinkBox = undefined;
    return false;
  }

  /**
   * Set the cursor to pointer when hovering over a link
   * @param gridPoint Mouse position information
   * @param grid The grid
   * @returns False
   */
  setCursor(gridPoint, grid) {
    if (this.isHoveringLink(gridPoint, grid)) {
      this.cursor = 'pointer';
    } else {
      this.cursor = null;
    }
    return false;
  }
  onMove(gridPoint, grid) {
    return this.setCursor(gridPoint, grid);
  }
  onDown(gridPoint, grid, event) {
    var isUserHoveringLink = this.isHoveringLink(gridPoint, grid);

    // If a modifier key or shift is down, we don't want to handle it and set isDown to false so onUp won't handle it either
    if (GridUtils.isModifierKeyDown(event) || event.shiftKey || !isUserHoveringLink) {
      return false;
    }
    this.isDown = true;
    if (this.timeoutId != null) {
      clearTimeout(this.timeoutId);
    }
    this.isHold = false;
    this.timeoutId = setTimeout(() => {
      this.isHold = true;
      var column = gridPoint.column,
        row = gridPoint.row;
      var model = grid.props.model;

      // After 1 second, select the row and if it is an input table, start editing
      grid.clearSelectedRanges();
      grid.focus();
      grid.moveCursorToPosition(column, row);
      if (isEditableGridModel(model) && column != null && row != null && model.isEditableRange(GridRange.makeCell(column, row))) {
        grid.startEditing(column, row);
      }
    }, GridTokenMouseHandler.HOLD_LENGTH);
    return true;
  }
  onClick(gridPoint, grid) {
    var isUserHoveringLink = this.isHoveringLink(gridPoint, grid);
    if (!isUserHoveringLink || !this.isDown || this.currentLinkBox == null) {
      this.isDown = false;
      this.isHold = false;
      return false;
    }

    // User is hovering a link, isDown is true
    // If isHold is true, then the select already happened so onUp shouldn't do anything
    if (!this.isHold) {
      var _this$currentLinkBox2;
      // Cancel the timeout and open a new tab with the link
      if (this.timeoutId != null) {
        clearTimeout(this.timeoutId);
      }
      this.timeoutId = undefined;
      grid.props.onTokenClicked((_this$currentLinkBox2 = this.currentLinkBox) === null || _this$currentLinkBox2 === void 0 ? void 0 : _this$currentLinkBox2.token);
    }
    this.isHold = false;
    this.isDown = false;
    return true;
  }
}
_defineProperty(GridTokenMouseHandler, "HOLD_LENGTH", 1000);
export default GridTokenMouseHandler;
//# sourceMappingURL=GridTokenMouseHandler.js.map